var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro"},[_c('h1',{staticClass:"intro__title"},[_vm._v(" "+_vm._s(_vm.$t('auth.welcome_to'))+" "),_c('strong',{staticClass:"bold"},[_vm._v("GES")])])])}
var staticRenderFns = []

export { render, staticRenderFns }